// クエリパラメータで言語を指定できるようにするmixin

import { setLanguage, resetLanguage } from '@/i18n'
import { Component, Vue } from 'vue-property-decorator'
import router from '@/router'

function getLangQuery() {
  return router.currentRoute.query.lang
    ? router.currentRoute.query.lang
    : new URLSearchParams(location.search).get('lang') // Vue Router が動かない場合
}

// for Vue component object
export const LanguageQueryMixin = {
  created() {
    setLanguage(getLangQuery() as string)
  },
}

// for vue-property-decorator
@Component
export class LanguageQueryHandler extends Vue {
  created() {
    setLanguage(getLangQuery() as string)
  }
}
